<template>
	<div class="percentageDetail-container">
		<div class="order-menu">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>{{ruleForm.id === '' ? '新建客户提成方案' : '客户提成方案'}}
		</div>
		<el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="110px" class="box">
			<div class="fx-title">
				<span>基础信息</span>
			</div>
			<el-form-item label="方案名称:">
				<el-input v-model="ruleForm.planname" size='mini' maxlength="15" style="width:200px;" placeholder="请输入方案名称"></el-input>
			</el-form-item>
			<el-form-item label="选择员工:">
				<el-button size="mini" plain type="primary" @click='addStaff'>选择员工</el-button>
			</el-form-item>
			<el-form-item label="已选:" v-if="chooseStaff.length !== 0">
				<el-button size='mini' class="remove-btn" v-for="item in staffBtnList" :key='item.id'>
					{{item.name}}
				</el-button>
			</el-form-item>
			<el-form-item label="选择客户:">
				<el-button size="mini" type="primary" plain @click='addCus'>选择客户</el-button>
			</el-form-item>
			<el-form-item label="已选:" v-if="chooseCus.length !== 0">
				<el-button size='mini' class="remove-btn" v-for="item in cusBtnList" :key='item.id'>
					{{item.name}}
				</el-button>
			</el-form-item>
			<el-form-item label="方案类型:">
				<el-radio v-model="ruleForm.plantype" :disabled="!AuthorityList['11_0001_0002_00']" :label="0">提成（仅支持按商品）</el-radio>
				<el-radio v-model="ruleForm.plantype" :disabled="!AuthorityList['11_0001_0002_00']" :label="1">{{ isCustomRebatePlan ? '返佣' : '返佣（仅支持按订单）' }}</el-radio>
				<el-select
					v-if="isCustomRebatePlan && ruleForm.plantype === 1"
					v-model="ruleForm.planway"
					:disabled="!AuthorityList['11_0001_0002_00']"
					size="mini"
					style="width: 100px; margin-right: 10px;">
					<el-option :value="1" label="按订单"></el-option>
					<el-option :value="0" label="按商品"></el-option>
				</el-select>
				<span>注：选择‘返佣’类型，员工可进行返佣提现打款申请，选择‘提成’类型，则仅进行员工提成统计！</span>
			</el-form-item>
			<el-form-item label="启用状态:">
				<el-radio v-model="ruleForm.disabledflag" :disabled="!AuthorityList['11_0001_0002_00']" :label="false">启用</el-radio>
				<el-radio v-model="ruleForm.disabledflag" :disabled="!AuthorityList['11_0001_0002_00']" :label="true">停用</el-radio>
				<span>注：启用后，该方案内员工的提成、返佣统计生效于当日零点。 如只是预设方案，请选择‘禁用’</span>
			</el-form-item>
		</el-form>

		<div class="fx-title">
			<span>设置提成/返佣方式</span>
		</div>
		<div v-if="isProductMode">
			<div class="select-box">
				<div>
					店铺级大类：
					<el-select v-model="bcId" class="input-box" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
				<div v-if="bigcategoryview === 1" style="margin-left: 10px;">
					店铺级小类：
					<el-select v-model="scId" class="input-box" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<div style="margin-left: 10px;">
					商品名称：
					<el-input v-model="productFilterStr"  size='mini' class='input-box' placeholder='请输入商品名称或编号'></el-input>
				</div>
				<!-- <div style="margin-left: 10px;">
					商品信息：
					<el-input v-model="productFilterStr"  size='mini' class='input-box'></el-input>
				</div>
				<div style="margin-left: 10px;">
					规格信息：
					<el-input v-model="specFilterStr"  size='mini' class='input-box'></el-input>
				</div> -->
				<el-button style="margin-left: 10px;" type="primary" size="mini" @click='selectClick'>查询</el-button>
				<el-button style="margin-left: 10px;" size="mini" plain @click='clearClick'>清空</el-button>
			</div>
			<div v-if='AuthorityList["11_0001_0002_00"]' style="text-align: left;">
				<el-button @click='addProductClick' :disabled="(chooseCus.length === 0 || chooseStaff.length === 0) && ruleForm.id ===''" type="primary" plain size="mini">+添加商品</el-button>
				<el-button v-if='AuthorityList["11_0001_0002_00"]' size="mini" type="primary" @click='allSet' plain>批量设置</el-button>
				<el-button v-if='AuthorityList["11_0001_0002_00"]' size="mini" type="primary" @click='delMore' plain>删除</el-button>
			</div>
			<div class="table-box">
				<el-table
					ref='table'
					:stripe='true'
					size='mini'
					class="grid-content"
					:data="tableData"
					:height="280"
					@selection-change="handleSelectionChange"
					border>
					<el-table-column
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						prop="productName"
						label="图片"
						min-width="90"
						align="center">
						<template slot-scope="scope">
							<div style="width: 100%;height: 90px;display: flex;align-items: center;justify-content: center;">
								<img v-if="scope.row.productUrl === ''" src="~/images/img/no-goods-img.png" style="width: 80px; height:80px">
								<w-image v-else :src="scope.row.productUrl" type="product" style="width: 80px;height:80px"></w-image>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="productName"
						label="商品"
						align="center"
						min-width="180">
					</el-table-column>
					<!-- <el-table-column
						prop="productCode"
						label="商品编号"
						align="center"
						min-width="180">
					</el-table-column> -->
					<el-table-column
						prop="bigCategoryName"
						label="店铺级大类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						v-if="bigcategoryview === 1"
						prop="smallCategoryName"
						label="店铺级小类"
						align="center"
						min-width="180">
					</el-table-column>
					<!-- <el-table-column
						prop="specName"
						label="规格"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="specCode"
						label="规格编号"
						align="center"
						min-width="180">
					</el-table-column> -->
					<el-table-column
						prop="commissiontype"
						label="提成规则"
						align="center"
						min-width="180">
						<template slot="header">
							提成规则
							<el-tooltip placement="top">
								<div slot="content">固定金额提成：每销售一件商品获取提成设置的固定提成金额（不包含赠品）<br/>百分比提成计算方式：商品实付金额*提成百分比=提成金额</div>
								<i style="color:var(--fx-primary-color);" class="el-icon-info"></i>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<div>
								<el-select v-model="scope.row.commissionType" @change="commissiontypeChange(scope.row)" style="width: 100px;" size='small'>
									<el-option :value="1" label="百分比"></el-option>
									<el-option :value="2" label="固定金额"></el-option>
								</el-select>
							</div>
							<!-- <div v-else>
								<span>{{scope.row.commissionType === 1 ? '百分比' : '固定金额'}}</span>
							</div> -->
						</template>
					</el-table-column>
					<el-table-column
						prop="commissionValue"
						label="金额/百分比"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div>
								<el-input size="mini" style="width: 150px;" @input='commissionvalueCheck(scope.row)' v-model="scope.row.commissionValue">
									<template slot="prepend">{{scope.row.commissionType === 1 ? '%' : '￥'}}</template>
								</el-input>
							</div>
							<!-- <div v-else>
								<span>{{scope.row.commissionValue}}</span>
							</div> -->
						</template>
					</el-table-column>
					<!-- <el-table-column
						v-if="isEdit"
						label="操作"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click='delItem(scope.row.id)'>删除</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<el-form v-if="isRebateProductMode" :model="ruleForm" :inline-message='true' label-position='right' label-width="110px" class="box">
				<el-form-item label="返佣打款周期:">
					<div class="period-box">
						<el-input size="mini" style="width:100px" @input='backInput' v-model="backValue">
							<template slot="prepend">T+</template>
						</el-input><span style="margin:0 40px 0 10px">工作日</span>注：在员工申请返佣提现且审核同意之后，T+n 工作日进行线下银行打款
					</div>
				</el-form-item>
				<el-form-item label="">
					<div style="line-height:30px;margin: 10px 0 20px;">
						说明：<br>
						1、百分比：每个订单实付金额按百分比进行员工返佣。<br>
						2、固定金额：每个客户完成一笔订单员工按固定金额返佣统计。<br>
						3、返佣金额达成条件：1、订单完成状态。2、没有未处理。3、订单超过可退款周期<br>
						4、‘员工’的银行账户信息，可在卖家后台-卖家-员工档案中维护，也可线下表格记录
					</div>
				</el-form-item>
			</el-form>
			<!-- <div class="page-box" v-if='ruleForm.id !==""'>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page.number"
					:page-sizes="[20,40, 60, 100, 500]"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div> -->
		</div>
		<div v-else>
			<el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="110px" class="box">
				<el-form-item label="方案方式:">
					<el-radio border v-model="ruleForm.backType" style="width:100px" :disabled="!AuthorityList['11_0001_0002_00']" size="small" :label="1">百分比</el-radio>
					<el-radio border v-model="ruleForm.backType" :disabled="!AuthorityList['11_0001_0002_00']" size="small" :label="2">固定金额</el-radio>
				</el-form-item>
				<el-form-item label="">
					<div class="period-box">
						<el-input size="mini" style="width:100px;margin-right: 40px;" @input='percentInput2(1)' v-model="backPercentValue">
							<template slot="prepend">%</template>
						</el-input>
						<el-input size="mini" style="width:100px" @input='percentInput2(2)' v-model="backMoneyValue">
							<template slot="prepend">￥</template>
						</el-input>
					</div>
				</el-form-item>
				<el-form-item label="返佣打款周期:">
					<div class="period-box">
						<el-input size="mini" style="width:100px" @input='backInput' v-model="backValue">
							<template slot="prepend">T+</template>
						</el-input><span style="margin:0 40px 0 10px">工作日</span>注：在员工申请返佣提现且审核同意之后，T+n 工作日进行线下银行打款
					</div>
				</el-form-item>
				<el-form-item label="">
					<div style="line-height:30px;margin: 10px 0 20px;">
						说明：<br>
						1、百分比：每个订单实付金额按百分比进行员工返佣。<br>
						2、固定金额：每个客户完成一笔订单员工按固定金额返佣统计。<br>
						3、返佣金额达成条件：1、订单完成状态。2、没有未处理。3、订单超过可退款周期<br>
						4、‘员工’的银行账户信息，可在卖家后台-卖家-员工档案中维护，也可线下表格记录
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot-btn-box" v-if='AuthorityList["11_0001_0002_00"]'>
			<!-- <el-button v-if="!isEdit" @click='editClick' type="primary" plain size="mini">修改提成</el-button> -->
			<!-- <el-button type="primary" plain size="small" @click='cancelEdit'>取消</el-button> -->
			<el-button type="primary" size="small" @click='saveClick'>保存</el-button>
		</div>
		<el-dialog
			:title="'批量修改提成 (已选' + selectIds.length + '条)'"
			:visible.sync="allSetDialog"
			class="dialog-title"
			width="450px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-percontent">
					<span style="flex-shrink:0">*提成方式:</span>
					<el-select v-model="methodValue" class="per-select" size='small' @change="methodChange">
						<el-option :value="2" label="固定金额"></el-option>
						<el-option :value="1" label="百分比"></el-option>
					</el-select>
					<div class="per-money">
						<el-input size="mini" class="per-input" @input='percentInput' v-model="percentValue">
							<template slot="prepend">{{methodValue === 2 ? '￥' : '%'}}</template>
						</el-input>
					</div>
				</div>
				<div style="text-align:center">
					<el-button class="btn" size="small" type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="multiSave">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="添加商品"
			:visible.sync="addProductShow"
			:close-on-click-modal = 'false'
			class="dialog-title"
			width="1000px">
			<addProduct v-if='addProductShow' @cancelProduct='cancelProduct' @saveProduct='saveProduct' :customerId='ruleForm.customer' :commissionPlanId ='ruleForm.id'></addProduct>
		</el-dialog>
		<el-dialog
			title="提示"
			append-to-body
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;" v-for="item in errorList" :key='item'>{{item}}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="选择客户"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<BindCustomer :commissionPlanId="isCustomRebatePlan ? ruleForm.id : ''" v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></BindCustomer>
			</div>
		</el-dialog>
		<el-dialog
			title="选择员工"
			:visible.sync="staffDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<BindStaff :commissionPlanId="isCustomRebatePlan ? ruleForm.id : ''" v-if="staffDialog" :staffDialog.sync="staffDialog" @reloadStaff='reloadStaff' :chooseStaff='chooseStaff'></BindStaff>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import addProduct from '@/components/percentageDetail/addProduct.vue'
import BindCustomer from './bindCustomer.vue'
import BindStaff from './bindStaff.vue'
export default {
	name: 'percentageDetail',
	components: {
		addProduct, BindCustomer, BindStaff
	},
	data () {
		return {
			AuthorityList: {
				'11_0001_0001_00': false,
				'11_0001_0002_00': false,
				'11_0002_0002_00': false
			},
			errorList: [],
			showError: false,
			allSetDialog: false,
			methodValue: 2,
			percentValue: '',
			selectIds: [],
			isEdit: false,
			customerCategoryName: '',
			productFilterStr: '',
			specFilterStr: '',
			bc: [],
			sc: [],
			bcId: '0',
			scId: '0',
			bigcategoryview: 0,
			total: 0,
			tableHeight: '100%',
			tableData: [],
			tableDataFix: [],
			addProductShow: false,
			page: {
				number: 1,
				size: 20
			},
			ruleForm: {
				id: '',
				staffid: '',
				customer: '',
				disabledflag: true,
				plantype: 0,
				planway: 1,
				planname: '',
				backType: 1
			},
			chooseStaff: [],
			staffDialog: false,
			customerDialog: false,
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			cusBtnList: [],
			staffBtnList: '',
			customertype: 0,
			backPercentValue: '',
			backMoneyValue: '',
			backValue: '3',
			isCustomRebatePlan: false,
			rules: {
				staff: [
					{ required: true, message: '请选择员工', trigger: 'change' }
				],
				customer: [
					{ required: true, message: '请选择客户', trigger: 'change' }
				]
			},
			fxDataVerification: this.$fxUtils.fxDataVerification()
		}
	},
	computed: {
		isProductMode () {
			return this.ruleForm.plantype === 0 || (this.ruleForm.plantype === 1 && this.ruleForm.planway === 0)
		},
		isRebateProductMode () {
			return this.ruleForm.plantype === 1 && this.ruleForm.planway === 0
		}
	},
	created () {
		this.getAuthority('11_0001_0000_00')
		this.getOrganInfo().then(() => {
			let id = window.sessionStorage.getItem('percentageId')
			if (id) {
				this.ruleForm.id = id
				this.getDetail()
			}
		})
		this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
		})
	},
	methods: {
		getOrganInfo () {
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				const syscode = String(res.syscode)
				this.isCustomRebatePlan = ['570', '674820', '985040'].includes(syscode)
				if (!this.isCustomRebatePlan && this.ruleForm.plantype === 1) {
					this.ruleForm.planway = 1
				}
			})
		},
		getPlanwayText (plantype, planway) {
			if (plantype === 0 || planway === 0) {
				return '按商品'
			}
			return '按订单'
		},
		isProductPlan (plantype, planway) {
			return plantype === 0 || (plantype === 1 && planway === 0)
		},
		addStaff () {
			this.staffDialog = true
		},
		addCus () {
			this.customerDialog = true
		},
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		initStaffData () {
			let textArr = []
			let list = this.chooseStaff
			list.forEach(item => {
				item.roleflag = item.categoryOrLevelFlag
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				let row = {
					name: itemText,
					id: item.id
				}
				textArr.push(row)
			})
			this.staffBtnList = textArr
			this.ruleForm.staffName = textArr.map(e => {
				return e.name
			}).join(',')
			// this.fxDataVerification.resetData(this.ruleForm)
		},
		initCusData () {
			let textArr = []
			let list = this.chooseCus
			list.forEach(item => {
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				let row = {
					name: itemText,
					id: item.id
				}
				textArr.push(row)
			})
			this.cusBtnList = textArr
			this.ruleForm.cusName = textArr.map(e => {
				return e.name
			}).join(',')
			// this.fxDataVerification.resetData(this.ruleForm)
		},
		initCusData1 (data) {
			data.forEach(item => {
				item.name = this.customertype === 0 ? item.categoryname : item.levelname
				item.id = this.customertype === 0 ? item.categoryid : item.levelid
				item.showCus = 0
			})
			return data
		},
		initStaffData1 (data) {
			data.forEach(item => {
				item.name = item.rolename
				item.id = item.roleid
				item.categoryOrLevelFlag = item.roleflag
				item.showCus = 0
			})
			return data
		},
		reloadStaff (data) {
			this.chooseStaff = data.chooseData
			this.initStaffData()
			// if (this.ruleForm.id !== '') {
			// 	this.disabledflagChange()
			// }
			this.staffDialog = false
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.initCusData()
			// if (this.ruleForm.id !== '') {
			// 	this.disabledflagChange()
			// }
			this.customerDialog = false
		},
		cancelProduct () {
			this.addProductShow = false
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		checkData () {
			if (this.chooseCus.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			if (this.chooseStaff.length === 0) {
				this.$message.error('请选择员工')
				return false
			}
			if (!this.isProductMode) {
				if ((this.ruleForm.backType === 1 && !this.backPercentValue) || (this.ruleForm.backType === 2 && !this.backMoneyValue)) {
					this.$message.error('请输入方案方式')
					return false
				}
				if (!this.backValue) {
					this.$message.error('请输入返佣打款周期')
					return false
				}
				return true
			} else {
				let arr = []
				if (this.tableDataFix.length !== 0) {
					this.tableDataFix.forEach(item => {
						if (item.commissionValue === '') {
							arr.push('【' + item.productName + '-' + item.specName + '】' + '提成方式不可为空！')
						}
					})
				} else {
					this.$message.error('至少添加一个商品')
					return false
				}
				if (arr.length > 0) {
					this.errorList = arr
					this.showError = true
					return false
				}
				if (this.ruleForm.plantype === 1 && !this.backValue) {
					this.$message.error('请输入返佣打款周期')
					return false
				}
				return true
			}
		},
		saveClick () {
			if (!this.checkData()) {
				return false
			}
			let params = {
				disabledflag: this.ruleForm.disabledflag,
				staffList: this.chooseStaff,
				customertype: this.customertype,
				customerList: this.chooseCus,
				id: this.ruleForm.id,
				planname: this.ruleForm.planname,
				plantype: this.ruleForm.plantype,
				planway: this.ruleForm.planway
			}
			if (this.isProductMode) {
				params.commissionPlanDetails = this.tableDataFix
			} else {
				params.commissionType = this.ruleForm.backType
				params.commissionValue = this.ruleForm.backType === 1 ? this.backPercentValue : this.backMoneyValue
			}
			if (this.ruleForm.plantype === 1) {
				params.cycleday = this.backValue
			}
			let logger = null
			if (this.ruleForm.id) {
				logger = this.$fxLogger.createInfo('results.scheme-setting.update', this.createLoggerParams())
			} else {
				let text = `【${this.ruleForm.planname}】【${this.ruleForm.plantype === 0 ? '提成' : '返佣'}】【${this.getPlanwayText(this.ruleForm.plantype, params.planway)}】`
				logger = this.$fxLogger.createInfo('results.scheme-setting.add', { name: text })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/save`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					// this.isEdit = false
					window.sessionStorage.setItem('percentageId', res.data.id)
					this.ruleForm.id = res.data.id
					this.$message.success('保存成功')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.staffName = this.staffBtnList.map(e => { return e.name }).join(',')
			ruleForm.cusName = this.cusBtnList.map(e => { return e.name }).join(',')
			const originIsProduct = this.isProductPlan(originData.plantype, originData.planway)
			const curIsProduct = this.isProductPlan(ruleForm.plantype, ruleForm.planway)
			if (originIsProduct !== curIsProduct) {
				if (curIsProduct) {
					let name = this.tableData.map(e => {
						return e.productName
					}).join(',')
					originData.product = ''
					ruleForm.product = `添加商品【${name}】`
				}
				if (!curIsProduct) {
					let text = `${this.ruleForm.backType === 2 ? '固定金额:￥' : '百分比:'}${this.ruleForm.backType === 2 ? this.backMoneyValue : this.backPercentValue}${this.ruleForm.backType === 2 ? '' : '%'}`
					originData.backText = ''
					ruleForm.backText = `方案方式为【${text}】,返佣打款周期为【T+${this.backValue}】个工作日`
				}
			} else {
				if (curIsProduct) {
					delete originData.backType
					delete originData.backPercentValue
					delete originData.backMoneyValue
					delete ruleForm.backType
					delete ruleForm.backPercentValue
					delete ruleForm.backMoneyValue
					if (ruleForm.plantype === 0) {
						delete originData.backValue
						delete ruleForm.backValue
					} else {
						ruleForm.backValue = this.backValue
					}
					if (originData.tableData.sort().toString() !== this.tableDataFix.sort().toString()) {
						let name = this.tableDataFix.map(e => {
							return e.productName
						}).join(',')
						originData.newProduct = ''
						ruleForm.newProduct = `商品修改为【${name}】`
					}
					let textArr = []
					let preType, curType, text, preValue, curValue, resultText
					originData.tableData.forEach(item => {
						this.tableDataFix.forEach(item2 => {
							if (item.productAttrplanId === item2.productAttrplanId && item.commissionType !== item2.commissionType) {
								preType = item.commissionType === 1 ? '百分比' : '固定金额'
								curType = item2.commissionType === 1 ? '百分比' : '固定金额'
								text = `【商品名称"${item.productName}"】:提成规则由"${preType}"改为"${curType}"`
								textArr.push(text)
							}
							if (item.productAttrplanId === item2.productAttrplanId && item.commissionValue !== item2.commissionValue) {
								preValue = item.commissionValue
								curValue = item2.commissionValue
								text = `【商品名称"${item.productName}"】:方式数值由"${preValue}"改为"${curValue}"`
								textArr.push(text)
							}
						})
					})
					resultText = textArr.join(',')
					originData.productResult = ''
					ruleForm.productResult = resultText
				}
				if (!curIsProduct) {
					delete originData.tableData
					delete ruleForm.tableData
					ruleForm.backValue = this.backValue
					ruleForm.backPercentValue = this.backPercentValue
					ruleForm.backMoneyValue = this.backMoneyValue
				}
			}
			console.log(originData, ruleForm)
			return {
				pre: originData,
				cur: ruleForm,
				name: originData.planname
			}
		},
		disabledflagChange () {
			if (this.ruleForm.id === '') {
				return false
			}
			let params = {
				id: this.ruleForm.id,
				disabledflag: this.ruleForm.disabledflag,
				staffList: this.chooseStaff,
				customertype: this.customertype,
				customerList: this.chooseCus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.ruleForm.id = res.data.id
					window.sessionStorage.setItem('percentageId', res.data.id)
					if (res.data.disabledReason) {
						this.$message.error(res.data.disabledReason)
					} else {
						this.$message.success('保存成功')
					}
					this.getDetail()
				} else {
					if (res.code === 1) {
						let list = res.data.disabledReasons
						let errorList = []
						list.forEach(item => {
							let row = '【' + item.customername + '】与【' + item.username + '】不能重复设置提成方案'
							errorList.push(row)
						})
						this.errorList = errorList
						this.showError = true
						return false
					}
					this.$message.error('处理失败，请稍后重试！')
				}
			})
		},
		cancelEdit () {
			this.getDetail()
			this.isEdit = false
		},
		close () {
			this.allSetDialog = false
		},
		multiSave () {
			if (!this.percentValue) {
				this.$message.error('提成方式不可为空！')
				return false
			}
			this.tableData.forEach(item => {
				if (this.selectIds.includes(item.productAttrplanId)) {
					item.commissionType = this.methodValue
					item.commissionValue = this.percentValue
				}
			})
			this.tableDataFix.forEach(item => {
				if (this.selectIds.includes(item.productAttrplanId)) {
					item.commissionType = this.methodValue
					item.commissionValue = this.percentValue
				}
			})
			this.selectIds = []
			this.$refs.table.clearSelection()
			this.allSetDialog = false
		},
		allSet () {
			if (this.selectIds.length === 0) {
				this.$message.error('未勾选需要处理的数据，请勾选')
				return false
			}
			this.methodValue = 2
			this.percentValue = ''
			this.allSetDialog = true
		},
		goBack () {
			window.sessionStorage.removeItem('percentageId')
			this.$router.push(`/main/percentage`)
		},
		percentInput () {
			this.percentValue = this.percentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (this.methodValue === 1) {
				if (+this.percentValue >= 1000) {
					this.percentValue = this.percentValue.substring(0, 3)
				} else {
					this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				if (+this.percentValue >= 10000) {
					this.percentValue = this.percentValue.substring(0, 4)
				} else {
					this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
		},
		percentInput2 (value) {
			if (value === 1) {
				this.backPercentValue = this.backPercentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
				if (+this.backPercentValue >= 1000) {
					this.backPercentValue = this.backPercentValue.substring(0, 3)
				} else {
					this.backPercentValue = this.backPercentValue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				this.backMoneyValue = this.backMoneyValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
				if (+this.backMoneyValue >= 10000) {
					this.backMoneyValue = this.backMoneyValue.substring(0, 4)
				} else {
					this.backMoneyValue = this.backMoneyValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
		},
		backInput () {
			this.backValue = this.backValue.replace(/[^0-9]/g, '')// 只能输入数字
		},
		methodChange () {
			this.percentValue = ''
		},
		commissiontypeChange (item) {
			item.commissionValue = ''
			this.tableDataFix.forEach(e => {
				if (e.productAttrplanId === item.productAttrplanId) {
					e.commissionType = item.commissionType
				}
			})
		},
		commissionvalueCheck (item) {
			item.commissionValue = item.commissionValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (item.commissionType === 1) {
				if (+item.commissionValue >= 1000) {
					item.commissionValue = item.commissionValue.substring(0, 3)
				} else {
					item.commissionValue = item.commissionValue.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				}
			} else {
				if (+item.commissionValue >= 10000) {
					item.commissionValue = item.commissionValue.substring(0, 4)
				} else {
					item.commissionValue = item.commissionValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				}
			}
			this.tableDataFix.forEach(e => {
				if (e.productAttrplanId === item.productAttrplanId) {
					e.commissionValue = item.commissionValue
				}
			})
		},
		editClick () {
			this.isEdit = true
		},
		clearClick () {
			// this.page = {
			// 	number: 1,
			// 	size: 20
			// }
			this.bcId = '0'
			this.scId = '0'
			this.getSmalCategory()
			this.productFilterStr = ''
			this.specFilterStr = ''
			this.tableData = this.tableDataFix
			// this.tableReload()
		},
		selectClick () {
			// this.page = {
			// 	number: 1,
			// 	size: 20
			// }
			// this.tableReload()
			this.tableData = this.tableDataFix.filter(e => {
				console.log(e.productName, e.productCode)
				return (e.productName.indexOf(this.productFilterStr) !== -1 || e.productCode.indexOf(this.productFilterStr) !== -1) && (this.bcId === e.shopCategoryBigId || this.bcId === '0') && (this.scId === e.shopCategorySmallId || this.scId === '0')
			})
		},
		handleSelectionChange (val) {
			let arr = []
			val.forEach(item => {
				arr.push(item.productAttrplanId)
			})
			this.selectIds = arr
		},
		tableReload () {
			let params = {
				commissionPlanId: this.ruleForm.id,
				page: this.page.number,
				size: this.page.size,
				bigCategoryId: this.bcId,
				smallCategoryId: this.scId,
				productFilterStr: this.productFilterStr,
				specFilterStr: this.specFilterStr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/detail/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.list
					this.tableDataFix = this.$fxUtils.deepClone(res.data.list)
					this.total = res.data.count
					this.$refs.table.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getDetail () {
			this.page = {
				number: 1,
				size: 20
			}
			let params = {
				commissionPlanId: this.ruleForm.id,
				page: 1,
				size: 1000
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/get`,
				data: params
			}).then(res => {
				if (res.result) {
					window.sessionStorage.setItem('percentageId', res.data.id)
					this.ruleForm.id = res.data.id
					this.ruleForm.disabledflag = res.data.disabledflag
					this.customertype = res.data.customertype
					this.ruleForm.planname = res.data.planname
					this.ruleForm.plantype = res.data.plantype
					this.ruleForm.planway = res.data.planway
					if (!this.isCustomRebatePlan && res.data.plantype === 1) {
						this.ruleForm.planway = 1
					}
					if (this.isProductPlan(res.data.plantype, this.ruleForm.planway)) {
						this.tableData = res.data.commissionPlanDetails
						this.tableDataFix = this.$fxUtils.deepClone(res.data.commissionPlanDetails)
						this.ruleForm.tableData = this.$fxUtils.deepClone(res.data.commissionPlanDetails)
						if (res.data.plantype === 1) {
							this.backValue = res.data.cycleday + ''
							this.ruleForm.backValue = res.data.cycleday + ''
						}
					} else {
						this.ruleForm.backType = res.data.commissionType
						if (res.data.commissionType === 1) {
							this.backPercentValue = res.data.commissionValue
							this.backMoneyValue = ''
							this.ruleForm.backPercentValue = res.data.commissionValue
							this.ruleForm.backMoneyValue = ''
						} else {
							this.backMoneyValue = res.data.commissionValue
							this.backPercentValue = ''
							this.ruleForm.backPercentValue = ''
							this.ruleForm.backMoneyValue = res.data.commissionValue
						}
						this.backValue = res.data.cycleday + ''
						this.ruleForm.backValue = res.data.cycleday + ''
					}
					if (this.$refs.table) {
						this.$refs.table.doLayout()
					}
					this.chooseCus = this.initCusData1(res.data.customerList)
					this.chooseStaff = this.initStaffData1(res.data.staffList)
					if (this.customertype === 0) {
						this.chooseCusByCate = this.chooseCus
					} else {
						this.chooseCusBylevel = this.chooseCus
					}
					this.initCusData()
					this.initStaffData()
					this.total = res.data.itemCount
					this.customerCategoryName = res.data.customerCategoryName
					console.log(this.ruleForm)
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveProduct (data) {
			// let params = data
			// params.disabledflag = this.ruleForm.disabledflag
			// params.staffList = this.chooseStaff
			// params.customerList = this.chooseCus
			// params.customertype = this.customertype
			// params.id = this.ruleForm.id
			this.tableData = this.tableData.concat(data)
			this.tableDataFix = this.tableDataFix.concat(data)
			this.addProductShow = false
			// console.log(this.tableData)
			// this.$store.dispatch('requestPost', {
			// 	url: `${this.$fxBaseApi.urlQIVShop}/commission/save`,
			// 	data: params
			// }).then(res => {
			// 	if (res.result) {
			// 		if (res.data.result) {
			// 			this.ruleForm.id = res.data.id
			// 			window.sessionStorage.setItem('percentageId', res.data.id)
			// 			this.addProductShow = false
			// 			if (res.msg === null) {
			// 				this.$message.success('保存成功！')
			// 			} else {
			// 				this.$message.success('保存成功,已停用，原因：' + res.msg)
			// 			}
			// 			this.getDetail()
			// 		} else {
			// 			this.$message.error(res.data.failedReason)
			// 		}
			// 	} else {
			// 		if (res.code === 1) {
			// 			let list = res.data.disabledReasons
			// 			let errorList = []
			// 			list.forEach(item => {
			// 				let row = '【' + item.customername + '】与【' + item.username + '】不能重复设置提成方案'
			// 				errorList.push(row)
			// 			})
			// 			this.errorList = errorList
			// 			this.showError = true
			// 			return false
			// 		}
			// 		this.$message.error(res.msg)
			// 	}
			// })
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			this.getSmalCategory()
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
					this.getSmalCategory()
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		},
		addProductClick () {
			this.addProductShow = true
		},
		delMore () {
			if (this.selectIds.length === 0) {
				this.$message.error('未勾选需要处理的数据，请勾选')
			} else {
				// console.log(this.selectIds, this.tableData)
				for (let i = this.tableData.length - 1; i >= 0; i--) {
					let item = this.tableData[i]
					if (this.selectIds.includes(item.productAttrplanId)) {
						this.tableData.splice(i, 1)
					}
				}
				for (let i = this.tableDataFix.length - 1; i >= 0; i--) {
					let item = this.tableDataFix[i]
					if (this.selectIds.includes(item.productAttrplanId)) {
						this.tableDataFix.splice(i, 1)
					}
				}
				// this.$confirm('确认列表数据全提成规则删除后不可恢复，是否继续', '提示', {
				// 	confirmButtonText: '删除',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	let params = {
				// 		commissionPlanId: this.ruleForm.id,
				// 		ids: this.selectIds.join(',')
				// 	}
				// 	this.$store.dispatch('requestPost', {
				// 		url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/detail/remove`,
				// 		data: params
				// 	}).then(res => {
				// 		if (res.result) {
				// 			this.$message.success('删除成功！')
				// 			this.getDetail()
				// 		}
				// 	})
				// }).catch(() => {})
			}
		},
		delItem (id) {
			let params = {
				commissionPlanId: this.ruleForm.id,
				ids: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/detail/remove`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getDetail()
				}
			})
		},
		deleteHandler () {
			return new Promise((resolve) => {
				let params = {
					commissionPlanId: this.ruleForm.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/commissionplan/detail/remove`,
					data: params
				}).then(res => {
					if (res.result) {
						resolve()
					}
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.percentageDetail-container{
	display :flex;
	flex-direction :column;
	overflow-y :auto;
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.box{
		.select-box1{
			width :200px;
		}
		.el-form-item >>> .el-form-item__content{
			text-align :left
		}
	}
	.select-box{
		width :100%;
		height :60px;
		min-height :60px;
		box-sizing:border-box;
		padding :0px 10px;
		display :flex;
		flex-direction :row;
		align-items :center
		.input-box{
			width:150px
		}
	}
	.batch-btn-box{
		width :100%;
		height: 60px;
		min-height :60px;
		line-height :60px;
		text-align :left
	}
	.dialog-percontent {
		display: flex
		align-items: center;
		margin: 20px 0 30px
		.per-select {
			width: 135px;
			margin: 0 10px
		}
		.per-money {
			position: relative
			.per-tag {
				position: absolute
				left: 1px
				top: 1px
				bottom: 1px;
				width: 40px;
				z-index: 9;
				display: flex;
				border-top-left-radius: 4px;
				border-bottom-left-radius: 4px;
				align-items: center;
				justify-content: center;
				background-color: #eee;
			}
			.per-input {
				width: 150px
				input {
					text-indent: 35px
				}
			}
		}
	}
	.table-box{
		flex :1;
		width :100%
		min-height :200px;
		margin-top: 15px;
	}
	.period-box {
		display: flex;
		align-items: center
		.el-input-group__prepend {
			padding: 0 10px
		}
	}
	.foot-btn-box{
		height :50px;
		width :100%;
		min-height :50px;
		line-height :50px;
		text-align :center;
		.el-button {
			width: 120px
		}
	}
	.add-product-container{
		height :500px;
		display :flex;
		flex-direction :column
	}
	.remove-btn{
		border:1px solid #EDF0FB;
		background-color :#F7FBFF;
		color :#333;
	}
}
</style>
<style lang="stylus">
.dialog-title {
	text-align: left
	.el-dialog__headerbtn{
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 20px;
		font-weight:blod;
		.el-icon-close{
			color:#fff
		}
	}
}
.percentageDetail-container{
	.el-dialog__body {
		padding: 0px 0px;
		color: #606266;
		font-size: 14px;
	}
	.dialog-title{
		.el-dialog__body {
			padding: 10px;
			color: #606266;
			font-size: 14px;
		}
	}
}
.period-box {
	.el-input-group__prepend {
		padding: 0 10px
	}
}
</style>
